<div *ngIf="!isOnline" class="network-popup" [class.show]="!isOnline">
    <div class="popup-content">
        <div class="status-indicator">
            <span class="material-symbols-outlined fs-20 text-white fw-extrabold">wifi_off</span>
            <div class="pulse"></div>
        </div>
        <div class="message">
            <h4 class="text-white">No Internet Connection</h4>
            <p class="text-white">Please check your internet connection and try again.</p>
            <p class="text-underline text-white fw-semibold">Retrying after {{timer}} seconds.</p>
        </div>
        <div class="actions">
            <button (click)="retryConnection()" class="retry-btn fs-18 fw-semibold">
                <span class="material-symbols-outlined fs-20">sync</span>
                Retry now
            </button>
        </div>
    </div>
    <div class="progress-bar" *ngIf="isRetrying"></div>
</div>
<div class="network-popup success" *ngIf="showConnectedPopUp" [class.show]="showConnectedPopUp">
    <div class="popup-content">
        <div class="status-indicator">
            <span class="material-symbols-outlined fs-20 text-white fw-extrabold">wifi</span>
            <div class="pulse"></div>
        </div>
        <div class="message w-100">
            <h4 class="text-white">You Are Back Online.</h4>
            <p class="text-white">Your connection has been restored.</p>
        </div>
    </div>
</div>